/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Unit_PriceInputs */

const vi_order_unit_price = /** @type {(inputs: Order_Unit_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn giá`)
};

/**

* @param {Order_Unit_PriceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_unit_price = /** @type {((inputs?: Order_Unit_PriceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Unit_PriceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_unit_price(inputs)
});